import React, { useEffect, useRef, useState } from 'react';
import { heroPoster, sections } from '../../mock';
import { scrollToId } from '../Navbar';

const OCEAN_VIDEO =
  'https://videos.pexels.com/video-files/2169880/2169880-hd_1920_1080_30fps.mp4';
const OCEAN_VIDEO_FALLBACK =
  'https://videos.pexels.com/video-files/1093662/1093662-hd_1920_1080_30fps.mp4';

export default function Hero() {
  const [loaded, setLoaded] = useState(false);
  const [videoReady, setVideoReady] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section id="home" className="relative h-screen w-full overflow-hidden bg-[#2b2a27]">
      <img
        src={heroPoster}
        alt="Malibu villa"
        className={`absolute inset-0 w-full h-full object-cover transition-all duration-[1400ms] ${
          loaded ? 'scale-100 opacity-100' : 'scale-110 opacity-0'
        }`}
      />

      <video
        ref={videoRef}
        className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-[1500ms] ${
          videoReady ? 'opacity-100' : 'opacity-0'
        }`}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        poster={heroPoster}
        onCanPlay={() => setVideoReady(true)}
        onError={() => {
          if (videoRef.current && videoRef.current.src !== OCEAN_VIDEO_FALLBACK) {
            videoRef.current.src = OCEAN_VIDEO_FALLBACK;
            videoRef.current.load();
            videoRef.current.play().catch(() => {});
          }
        }}
      >
        <source src={OCEAN_VIDEO} type="video/mp4" />
        <source src={OCEAN_VIDEO_FALLBACK} type="video/mp4" />
      </video>

      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/10 to-black/55" />

      {/* Left-side vertical nav, seventy.blue style */}
      <nav className="hidden lg:flex absolute left-10 top-1/2 -translate-y-1/2 flex-col gap-8 z-10">
        <div className="w-px h-20 bg-white/50" />
        {sections.slice(1, -1).map((s) => (
          <button
            key={s.id}
            onClick={() => scrollToId(s.id)}
            className="font-sans-ui text-[10px] text-white/80 hover:text-white tracking-[0.3em] transition-colors text-left"
          >
            {s.label}
          </button>
        ))}
        <div className="w-px h-20 bg-white/50" />
      </nav>

      {/* Top right coord tag */}
      <div className="absolute top-24 right-6 md:right-10 z-10 hidden md:block">
        <div className="font-sans-ui text-[10px] text-white/85 text-right leading-relaxed">
          34.0259&deg; N &nbsp; 118.7798&deg; W
          <div className="mt-1 tracking-[0.3em]">Malibu &mdash; California</div>
        </div>
      </div>

      <div
        className={`relative z-10 h-full flex flex-col items-center justify-center text-center text-white px-6 transition-all duration-1000 ${
          loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}
        style={{ transitionDelay: '500ms' }}
      >
        <h1 className="font-serif-display text-[48px] md:text-[84px] lg:text-[108px] font-light tracking-[0.05em] leading-[0.95] uppercase">
          your vision
        </h1>
        <h1 className="font-serif-display text-[48px] md:text-[84px] lg:text-[108px] font-light tracking-[0.05em] leading-[1.05] italic lowercase -mt-2 md:-mt-3">
          realized
        </h1>
        <div className="mt-10 font-sans-ui text-[10px] md:text-[11px] tracking-[0.5em] text-white/90">
          Los Angeles Build Experts
        </div>
      </div>

      <button
        onClick={() => scrollToId('custom-homes')}
        aria-label="Scroll down"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10"
      >
        <div className="w-px h-12 bg-white/60 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-4 bg-white animate-[scrollLine_2.2s_ease-in-out_infinite]" />
        </div>
      </button>

      <style>{`
        @keyframes scrollLine {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(400%); }
        }
      `}</style>
    </section>
  );
}
